import React from 'react';

interface CommentProps {
  width?: string;
  height?: string;
}
const Comment = ({ width = '16', height = '16' }: CommentProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1243 11.124C9.34155 12.907 6.70172 13.2922 4.54142 12.2931C4.22251 12.1647 3.96105 12.061 3.71248 12.061C3.02013 12.0651 2.15836 12.7364 1.71048 12.289C1.26259 11.8411 1.93442 10.9786 1.93442 10.2821C1.93442 10.0335 1.83476 9.77672 1.70637 9.45718C0.706834 7.29724 1.09258 4.65653 2.87533 2.87416C5.15111 0.597545 8.84853 0.597545 11.1243 2.87358C13.4042 5.15371 13.4001 8.84801 11.1243 11.124Z"
        stroke="#7A7A7A"
        strokeWidth="1.01111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.29783 7.24089H9.30308"
        stroke="#7A7A7A"
        strokeWidth="1.55556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.95896 7.24089H6.96421"
        stroke="#7A7A7A"
        strokeWidth="1.55556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6201 7.24089H4.62535"
        stroke="#7A7A7A"
        strokeWidth="1.55556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Comment;
